import { useEffect, useState } from 'react';

import {
  ActionDialogButtons,
  ActionDialogContent,
  Button,
  ButtonGroup,
  Dialog,
  DialogContent,
} from '@opositandopn/ui';
import { PiBarbell } from 'react-icons/pi';

import { useProfile } from '../../../../context/ProfileContext';
import { useUpdateUser } from '../../../users/api/useUsers';

import styles from './SelectGenderDialog.module.scss';

function SelectGenderDialog() {
  const { profile } = useProfile();
  const { mutate: updateUser, isPending: isUpdatingUser } = useUpdateUser();

  const [selectedGender, setSelectedGender] = useState<'male' | 'female' | ''>(
    '',
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (profile.id !== undefined && profile.gender === undefined) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [profile.id, profile.gender]);

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        if (value) {
          setOpen(true);
        }
      }}
    >
      <DialogContent>
        <ActionDialogContent
          className={styles['dialog-content']}
          icon={<PiBarbell />}
          title="Completa tu perfil"
          subtitle="Para calcular tu puntuación según los baremos oficiales, necesitamos conocer tu género."
        >
          <ButtonGroup
            className={styles['gender']}
            label="Género"
            onSelect={(value: string | number) =>
              setSelectedGender(value as 'male' | 'female')
            }
            options={[
              {
                value: 'male',
                label: 'Hombre',
                selected: selectedGender === 'male',
              },
              {
                value: 'female',
                label: 'Mujer',
                selected: selectedGender === 'female',
              },
            ]}
          />
          <ActionDialogButtons>
            <Button
              variant="primary"
              disabled={selectedGender === '' || isUpdatingUser}
              loading={isUpdatingUser}
              onClick={() => {
                if (selectedGender === '' || profile.id === undefined) {
                  return;
                }

                updateUser({
                  id: profile.id,
                  gender: selectedGender,
                });
              }}
            >
              Enviar
            </Button>
          </ActionDialogButtons>
        </ActionDialogContent>
      </DialogContent>
    </Dialog>
  );
}

export { SelectGenderDialog };
